<template>
<div class="page_home_other col-lg-8 mb-8">

    <!-- title -->
    <v-chip class="font-size:3rem;" text-color="white" color="primary">{{content[$route.path].name}}</v-chip>
    <br><br>

    <!-- images -->
    <div v-for="pic in content[$route.path].pics" :key="pic.name">
        <img :src="pic" width="100%">
    </div>

    <!-- text -->
    <div v-html="content[$route.path].text"></div>
    
</div>
</template>

<script>
import config from '../../common/config';

export default {
    watch: {
        async $route (to, from){
            window.scrollTo(0, 0)
        },
    },
    data() {
        return {
            content: {
                '/faq/faq-1': {
                    name: '常見問題 / 考試',
                    pics: [
                        require('page/_home/img/faq-1-1.png'),
                        require('page/_home/img/faq-1-2.png'),
                        require('page/_home/img/faq-1-3.png'),
                        require('page/_home/img/faq-1-4.png'),
                    ],
                },
                '/faq/faq-2': {
                    name: '常見問題 / 招生',
                    pics: [
                        require('page/_home/img/faq-2-1.png'),
                        require('page/_home/img/faq-2-2.png'),
                        require('page/_home/img/faq-2-3.png'),
                        require('page/_home/img/faq-2-4.png'),
                        require('page/_home/img/faq-2-5.png'),
                    ],
                },
                '/faq/faq-3': {
                    name: '常見問題 / 諮詢',
                    pics: [require('page/_home/img/faq-3-1.png')],
                },
                '/service': {
                    name: '諮詢管道',
                    pics: [
                        require('page/_home/img/U2/U2_01.gif'),
                        require('page/_home/img/U2/U2_02.gif'),
                        require('page/_home/img/U2/U2_03.gif'),
                        require('page/_home/img/U2/U2_04.gif'),
                        require('page/_home/img/U2/U2_05.gif'),
                        require('page/_home/img/U2/U2_06.gif'),
                        require('page/_home/img/U2/U2_07.gif')
                    ],
                },
                '/about': {
                    name: '理念與精神',
                    pics: [require('page/_home/img/about.png')],
                },
                '/examinations/exam-1': {
                    name: '考試方式 / 學科能力測驗',
                    pics: [require('page/_home/img/exam-1.png')],
                },
                '/examinations/exam-2': {
                    name: '考試方式 / 指定科目考試',
                    pics: [require('page/_home/img/exam-2.png')],
                },
                '/examinations/exam-3': {
                    name: '考試方式 / 術科考試',
                    pics: [require('page/_home/img/exam-3.png')],
                },
                '/examinations/exam-4': {
                    name: '考試方式 / 高中英文聽力測驗',
                    pics: [require('page/_home/img/exam-4.png')],
                },
                '/admissions/admission-1': {
                    name: '入學管道 / 繁星推薦',
                    pics: [
                        require('page/_home/img/admission1-3.png'),
                        require('page/_home/img/admission1-1.png'),
                        require('page/_home/img/admission1-2.png')
                    ],
                },
                '/admissions/admission-2': {
                    name: '入學管道 / 申請入學',
                    pics: [
                        require('page/_home/img/admission2-2.png'),
                        require('page/_home/img/admission2-1.png'),
                    ],
                },
                '/admissions/admission-3': {
                    name: '入學管道 / 分發入學',
                    pics: [
                        require('page/_home/img/admission3-2.png'),
                        require('page/_home/img/admission3-1.png'),
                    ],
                },
                '/admissions/admission-4': {
                    name: '入學管道 / 特殊選才',
                    pics: [
                        require('page/_home/img/admission4-2.png'),
                        require('page/_home/img/admission4-1.png'),
                    ],
                },
                '/admissions/admission-5': {
                    name: '入學管道 / 單獨招生',
                    pics: [require('page/_home/img/admission5.png')],
                },
                '/relations': {
                    name: '考試與入學管道',
                    pics: [require('page/_home/img/relation.png')],
                },
                '/schedule': {
                    name: '重要日程表',
                    pics: [
                        require('page/_home/img/im-1.png'),
                        require('page/_home/img/im-2.png'),
                    ],
                },
                '/revision/revision-1': {
                    name: `${config.syear} 學年度的招考制度`,
                    pics: [require('page/_home/img/revision1.png')],
                },
                '/revision/revision-2': {
                    name: `${config.syear} 學年度的招考制度`,
                    pics: [require('page/_home/img/revision2.png')],
                },
                '/srecruit-1': {
                    name: '特殊選才招生管道',
                    pics: [
                        require('page/_home/img/admission4-2.png'),
                        require('page/_home/img/admission4-1.png'),
                    ],
                },
                '/collego': {
                    name: 'ColleGo!系統簡介',
                    pics: [require('page/_home/img/collego.png')],
                },
                '/plan': {
                    name: '入學方案簡表',
                    pics: [
                        require('page/_home/img/plan-1.png'),
                        require('page/_home/img/plan-2.png'),
                        require('page/_home/img/plan-3.png'),
                    ],
                },
                '/flowchart': {
                    name: '入學方案架構圖',
                    pics: [require('page/_home/img/flowchart.png')],
                },
                '/agency': {
                    name: '考試及招生單位',
                    pics: [
                        require('page/_home/img/U1/U1_01.gif'),
                        require('page/_home/img/U1/U1_02.gif'),
                        require('page/_home/img/U1/U1_03.gif'),
                        require('page/_home/img/U1/U1_04.gif'),
                        require('page/_home/img/U1/U1_05.gif'),
                        require('page/_home/img/U1/U1_06.gif'),
                    ],
                },
                '/calendar': {
                    name: `${config.syear} 學年度行事曆`,
                    text: `
                        <iframe src="https://calendar.google.com/calendar/embed?height=600&amp;wkst=2&amp;bgcolor=%23ffffff&amp;ctz=Asia%2FTaipei&amp;src=bDMybjRidWoyZDl1YXVwamVmZTY5dnA2ZGdAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=NGpvMnRwMGEyZjJzNWdmbHM4dTNxaTVuMTRAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=NzVmYWhxNW43OXE4OXM5M3F1Y2Y5MzlnbW9AZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=ODI4dXZrcjI2MTUwcG5icWgwZTM2Nm9kbWdAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=cWN2cXAzNGJ1cGw1ZGxsOW52ZzZobXEyMmtAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=YnNlMGUwNW9qMmd0aWp1cWVyaDBmMXA2OW9AZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=aDM0ZWxxZ2VpY2d1Z2d0N2pydW1mcm1jNHNAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;color=%239E69AF&amp;color=%23AD1457&amp;color=%23EF6C00&amp;color=%23009688&amp;color=%237986CB&amp;color=%23C0CA33&amp;color=%23E67C73&amp;showTitle=0" style="border:solid 1px #777" width="100%" height="600" frameborder="0" scrolling="no"></iframe>
                    `
                },
            }
        }
    },
}
</script>

<style lang="scss">
.page_home_other {
    .v-chip__content {
        font-size: 1.5rem;
    }
}
</style>
